import React from 'react'

const VerticalCardBodyTop: React.FC = props => {
    return <>{props.children}</>
}

export default VerticalCardBodyTop
